module.exports = __webpack_public_path__ + "media/images/common/h3_category-7ab61d3de3123ea7a8a96d17bb2e36e9.gif";